import styled from 'styled-components';

const TableSearchWrapper = styled.div`
    padding: 10px 0 15px;
    border-bottom: 1px solid #dee2e6;
`;

export default TableSearchWrapper;
